import createActions from 'utils/redux/createActions'

export default createActions([
  'PUSH_NOTIFICATION', //Using for draw new notification
  'DISMISS_NOTIFICATION', //Draw fadeout of not needed/old notification
  'CLEAR_DISSMISED', //To prevent redraw of dissmised item
  'CLEAR_ALL'//For clear state of showing notifications
])



// WEBPACK FOOTER //
// ./src/actions/notifications.js